import React from "react";
import { TimeAgo } from "../utils/timeAgo";
import { IoIosArrowBack } from "react-icons/io";
import { userDateTimeJalali } from "../utils/userDateTimeJalali";

type Props = {
  title: string;
  message: string;
  date: string;
  time: string;
  created_at: string;
  notification_type:
    | "NORMAL_NOTIFICATION"
    | "SUCCESS_NOTIFICATION"
    | "FAIL_NOTIFICATION";
  notification_uid: string;
  is_read: boolean;
  onClickIcon: () => void;
  mode?: "isPage" | null;
};

export default function NotificationCart(props: Props) {
  const notifTypeHandler = () => {
    switch (props.notification_type) {
      case "FAIL_NOTIFICATION":
        return "bg-red-400";

      case "NORMAL_NOTIFICATION":
        return "bg-primary-400";

      case "SUCCESS_NOTIFICATION":
        return "bg-green-400";
    }
  };
  return (
    <div
      onClick={props.onClickIcon}
      className={`p-3 ${
        props.mode === "isPage"
          ? !props.is_read
            ? "bg-gray-50"
            : "bg-white border-2 border-gray-200"
          : ""
      } flex  items-start  rounded-lg cursor-pointer`}
    >
      <div className="basis-[15px] mt-2 ml-2">
        <div className={`rounded-full w-3 h-3 ${notifTypeHandler()} `} />
      </div>
      <div className="flex justify-between w-full">
        <div>
          <p className="text-gray-900 text-BodyText/14/Regular">
            {props.title}
          </p>
          {!props.mode ? (
            <span className="text-gray-500 text-BodyText/12/Light">
              {TimeAgo(props.created_at)}
            </span>
          ) : (
            <div>
              <span className="text-gray-400 text-BodyText/12/Light">
                {userDateTimeJalali(props.created_at).date}
              </span>
              <span className="text-gray-400 text-BodyText/12/Light ml-2">
                {userDateTimeJalali(props.created_at).time}
              </span>
            </div>
          )}
        </div>
        <div className="mr-2 flex flex-col items-end mt-2">
          {props.mode === "isPage" && !props.is_read && (
            <div className="animate-pulse w-[6px] h-[6px] bg-primary-600 mb-4 rounded-full ml-1" />
          )}
          <div onClick={props.onClickIcon}>
            <IoIosArrowBack className="text-gray-400 cursor-pointer" />
          </div>
        </div>
      </div>
    </div>
  );
}
